/** Preset swatches = the D7 colour-word map (EPIC-112) so a manual pick matches what the server would have chosen. */
export const KIT_PRESETS: { hex: string; key: string }[] = [
  { hex: "#ffffff", key: "white" },
  { hex: "#000000", key: "black" },
  { hex: "#1d4ed8", key: "blue" },
  { hex: "#38bdf8", key: "lightBlue" },
  { hex: "#dc2626", key: "red" },
  { hex: "#16a34a", key: "green" },
  { hex: "#facc15", key: "yellow" },
  { hex: "#f97316", key: "orange" },
  { hex: "#7c3aed", key: "purple" },
  { hex: "#6b7280", key: "gray" },
  { hex: "#7f1d1d", key: "maroon" },
  { hex: "#ec4899", key: "pink" },
  { hex: "#ca8a04", key: "gold" },
  { hex: "#9ca3af", key: "silver" },
];

export const HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;
